import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-export",
  "use": "icon-export-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-export\"><defs><style type=\"text/css\"></style></defs><path d=\"M687.57 58.3v141.9h149.48zM193.07 157.95h-70.99V877.5h576.06v-69.77H193.07z\" p-id=\"5339\" /><path d=\"M637.72 58.3h-398.7v709.99h598.03V247.73H637.74l-0.02-189.43z m-59.95 542.17v-83.64H364.08v-95.49h213.69V337.7l181.54 131.38-181.54 131.39z\" p-id=\"5340\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol